"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Limits = void 0;
const LimitAction_1 = require("../LimitAction");
exports.Limits = {
    create: (definition) => {
        const limits = Object.entries(definition).reduce((limits, [limitKey, actionDefinition]) => {
            return Object.assign(Object.assign({}, limits), { [limitKey]: LimitAction_1.LimitAction.create(limitKey, actionDefinition) });
        }, {});
        return Object.assign(Object.assign({}, limits), { getAllActions: () => {
                return Object.values(limits);
            } });
    },
};
